class DetailsModal extends HTMLElement {
  constructor() {
    super();

    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    if (this.detailsContainer) {
      this.detailsContainer.addEventListener('keyup', (event) => {
        if (event.code.toUpperCase() === 'ESCAPE') {
          this.close();
        }
      });
    }

    if (this.summaryToggle) {
      this.summaryToggle.addEventListener(
        'click',
        this.onSummaryClick.bind(this)
      );

      this.summaryToggle.setAttribute('role', 'button');
    }

    const closeButton = this.querySelector(
      'button[type="button"]'
    );

    if (closeButton) {
      closeButton.addEventListener(
        'click',
        this.close.bind(this)
      );
    }
  }

  isOpen() {
    return this.detailsContainer?.hasAttribute('open') ?? false;
  }

  onSummaryClick(event) {
    event.preventDefault();

    const details = event.target.closest('details');

    if (!details) {
      return;
    }

    if (details.hasAttribute('open')) {
      this.close();
    } else {
      this.open(event);
    }
  }

  onBodyClick(event) {
    if (
      !this.contains(event.target) ||
      event.target.classList.contains('modal-overlay')
    ) {
      this.close(false);
    }
  }

  open(event) {
    if (!this.detailsContainer) {
      return;
    }

    const details = event.target.closest('details');

    if (!details) {
      return;
    }

    this.onBodyClickEvent =
      this.onBodyClickEvent ||
      this.onBodyClick.bind(this);

    details.setAttribute('open', true);

    document.body.addEventListener(
      'click',
      this.onBodyClickEvent
    );

    document.body.classList.add('overflow-hidden');

    const focusTarget =
      this.detailsContainer.querySelector(
        '[tabindex="-1"]'
      );

    const inputTarget =
      this.detailsContainer.querySelector(
        'input:not([type="hidden"])'
      );

    if (focusTarget) {
      trapFocus(
        focusTarget,
        inputTarget
      );
    }
  }

  close(focusToggle = true) {
    // IMPORTANT: prevent null error
    if (!this.detailsContainer) {
      return;
    }

    removeTrapFocus(
      focusToggle ? this.summaryToggle : null
    );

    this.detailsContainer.removeAttribute('open');

    if (this.onBodyClickEvent) {
      document.body.removeEventListener(
        'click',
        this.onBodyClickEvent
      );
    }

    document.body.classList.remove(
      'overflow-hidden'
    );
  }
}

customElements.define(
  'details-modal',
  DetailsModal
);